"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const IOptions_1 = require("../../../../interfaces/options/IOptions");
const AbstractObfuscatingReplacer_1 = require("../AbstractObfuscatingReplacer");
const NodeFactory_1 = require("../../../../node/NodeFactory");
const NumberUtils_1 = require("../../../../utils/NumberUtils");
const Utils_1 = require("../../../../utils/Utils");
let NumberLiteralObfuscatingReplacer = class NumberLiteralObfuscatingReplacer extends AbstractObfuscatingReplacer_1.AbstractObfuscatingReplacer {
    constructor(options) {
        super(options);
        this.numberLiteralCache = new Map();
    }
    replace(literalNode) {
        const literalValue = literalNode.value;
        if (typeof literalValue !== 'number') {
            throw new Error('`NumberLiteralObfuscatingReplacer` should accept only literals with `number` value');
        }
        let rawValue;
        if (this.numberLiteralCache.has(literalValue)) {
            rawValue = this.numberLiteralCache.get(literalValue);
        }
        else {
            if (!NumberUtils_1.NumberUtils.isCeil(literalValue)) {
                rawValue = String(literalValue);
            }
            else {
                rawValue = `${Utils_1.Utils.hexadecimalPrefix}${NumberUtils_1.NumberUtils.toHex(literalValue)}`;
            }
            this.numberLiteralCache.set(literalValue, rawValue);
        }
        return NodeFactory_1.NodeFactory.literalNode(literalValue, rawValue);
    }
};
NumberLiteralObfuscatingReplacer = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _a : Object])
], NumberLiteralObfuscatingReplacer);
exports.NumberLiteralObfuscatingReplacer = NumberLiteralObfuscatingReplacer;
